export const payloadBillingDetails = (values) =>
/**
 * Payload our form data to conform to stripe api billing.
 */
	values.useContactAddress
		? {
				city: values.contactCity,
				country: "CA",
				line1: values.contactAddress,
				postal_code: values.contactPostalCode,
				state: values.contactProvince,
		  }
		: {
				city: values.billingCity,
				country: "CA",
				line1: values.billingAddress,
				postal_code: values.billingPostalCode,
				state: values.billingProvince,
		  };
